
import { DEFAULT_LANDING_PAGE_TITLE } from '../lib/seo'
import LandingPage from '~/components/LandingPage.vue'

export default {
  components: { LandingPage },
  async asyncData({ $prismic, params, error }) {
    try {
      const document = await $prismic.api.getByUID(
        'landing_page',
        params.slug,
        {
          fetchLinks: [
            'team_member.name',
            'team_member.bio',
            'team_member.linkedin',
            'team_member.portrait',
            'team_member.attribution',
          ],
        }
      )
      return {
        document,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  head() {
    return {
      title:
        (this.document &&
          this.document.data &&
          this.document.data.page_title) ||
        DEFAULT_LANDING_PAGE_TITLE,
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content:
            this.document &&
            this.document.data &&
            this.document.data.exclude_from_sitemap
              ? 'noindex, nofollow'
              : 'index, follow',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.document &&
            this.document.data &&
            this.document.data.meta_description,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.document &&
            this.document.data &&
            this.document.data.meta_description,
        },
      ],
    }
  },
}
